(function () {
    'use strict';

    angular.module("imApp").factory("acLedgerHistoryImportService", ['$ihttp', function ($ihttp) {
        let service = {
            getAcLedgerHistoryImport: function (parms) {
                return $ihttp.post({
                    method: 3007,
                    parameters: parms || {}
                });
            },
            listYears: function (parms) {
                return $ihttp.post({
                    method: 3009,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
